export const CREATED_SUCCESS = "Create successful";
export const UPDATED_SUCCESS = "Update successful";
